export type ChannelType =
  | 'personal'
  | 'institutional'
  | 'department'
  | 'community'
  | 'cohort'
  | 'government'
  | 'enterprise'
  | 'partner';

export type ChannelVisibility = 'public' | 'org' | 'network' | 'private';

export interface Channel {
  id: string;
  handle: string;
  displayName: string;
  description?: string;
  avatarUrl?: string | null;
  bannerUrl?: string | null;
  type: ChannelType;
  ownerUserId: string;
  ownerEmail: string;
  slug: string;
  externalOrgName?: string | null;
  externalOrgLogoUrl?: string | null;
  agreementId?: string | null;
  agreementExpiresAt?: string | null;
  visibility: ChannelVisibility;
  shareToken: string;
  shareUrl?: string | null;
  tags: string[];
  subject?: string | null;
  level?: 'K12' | 'HED' | 'Postgraduate' | 'General' | null;
  language?: string | null;
  category?: string | null;
  subscriberCount: number;
  videoCount: number;
  isActive?: boolean;
  createdAt: string;
  updatedAt: string;
}

export const CHANNEL_TYPE_LABELS: Record<ChannelType, string> = {
  personal: 'Personal',
  institutional: 'Institucional',
  department: 'Departamento',
  community: 'Comunidad',
  cohort: 'Cohorte / Grupo',
  government: 'Gubernamental',
  enterprise: 'Empresa',
  partner: 'Aliado',
};

export const CHANNEL_TYPE_BADGES: Record<ChannelType, string> = {
  personal: '',
  institutional: '🏛',
  department: '🎓',
  community: '👥',
  cohort: '📚',
  government: '🏛',
  enterprise: '🏢',
  partner: '🤝',
};

export const VISIBILITY_LABELS: Record<ChannelVisibility, string> = {
  public:  'Público',
  org:     'Organización',
  network: 'Red de Confianza',
  private: 'Privado',
};
